import { Flex, Text } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'
import React from 'react'
import { textStyleKeys } from '~/themes/textStyles'

export const bounceAnimation = keyframes`
  0%,
  70%,
  100% {
      transform: translateY(0);
      opacity: 1;
  }
  80% {
      opacity: 0.8;
  }
  90% {
      opacity: 0.6;
      transform: translateY(-4px);
  }
  95% {
      opacity: 0.4;
      transform: translateY(-2px);
  }
`

interface BouncingEllipsisProps {
  styles?: {
    ellipsis?: Record<string, any>
  }
}

const defaultEllipsisStyle = {
  display: 'inline-block',
  animation: `${bounceAnimation} 2s infinite ease-in-out`,
  textStyle: textStyleKeys.Body1_Bold,
}

export const BouncingEllipsis: React.FC<BouncingEllipsisProps> = ({
  styles,
}) => {
  const ellipsisStyle = styles?.ellipsis || defaultEllipsisStyle

  return (
    <Flex alignItems="center" gap="2px">
      {[0, 1, 2].map((index) => (
        <Text
          key={index}
          as="span"
          sx={{
            ...ellipsisStyle,
            animationDelay: `${index * 0.15}s`,
          }}
        >
          .
        </Text>
      ))}
    </Flex>
  )
}
